import { render, staticRenderFns } from "./AgGridTable.vue?vue&type=template&id=aff82ad4&"
import script from "./AgGridTable.vue?vue&type=script&lang=js&"
export * from "./AgGridTable.vue?vue&type=script&lang=js&"
import style0 from "./AgGridTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports